import React from 'react'
import Input from 'react-debounce-input'

const DebouncedInput = props => {
  return (
    <div className="ui input">
      <Input {...props} />
    </div>
  )
}

export default DebouncedInput
